<template>
  <div
    v-if="message"
    class="c-tooltip"
  >
    <span
      v-if="positionClass=='top' && active"
      :class="'c-tooltip__container--' + positionClass"
      class="c-tooltip__container"
    ><Wysiwyg :html="message" /></span>

    <div
      class="c-tooltip__slot-wrapper"
      @mouseleave="active = false"
      @mouseover="active = true"
    >
      <slot />
    </div>

    <span
      v-if="positionClass=='bottom' && active"
      :class="containerClass"
    ><Wysiwyg :html="message" /></span>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import Wysiwyg from "../wysiwyg/Wysiwyg"
export default {
  name: 'Tooltip',
  components: {
    Wysiwyg
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'bottom'
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      active: false
    }
  },
  computed: {
    positionClass() {
      if (this.position == 'top' || this.position == 'bottom'){
        return this.position;
      } else {
        console.warn("Tooltip: Invalid position, use top or bottom");
        return 'bottom';
      }
    },
    containerClass() {
      let results = 'c-tooltip__container'
      if (this.position) {
        results+= ' c-tooltip__container--' + this.position;
      }
      if (this.error) {
        results+= ' c-tooltip__container--error';
      }
      return results;
    }
  }
};
</script>

<style lang="scss" scoped>

.c-tooltip {
  position: relative;
  width: inherit;
  &__container {
    max-width: rem(300px);
    padding: rem(8px);
    border: $input-border;
    border-radius: 4px;
    font-size: rem(18px);
    position: absolute;
    z-index: $zindex-tooltip + 1;
    pointer-events: none;

    @include themify($themes) {
      border-color: themed('foreground', 'section-border');
      color: themed('foreground', 'text-xx-light');
      background-color: themed('background', 'xx-light')
    }
    &--error {
      @include themify($themes) {
        color: themed('foreground', 'error');
        background-color: themed('background', 'xx-light')
      }
    }

    &--bottom {
      margin-top:rem(8px);
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 10px;
        left: 12px;
        top: -20px;
        @include themify($themes) {
          border-color: transparent transparent themed('foreground', 'section-border');
        }
        z-index: $zindex-tooltip;
      }

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        top: -18px;
        left: 12px;
        border-width: 10px;
        z-index: $zindex-tooltip + 2;
        @include themify($themes) {
          border-color: transparent transparent themed('background', 'xx-light') transparent;
        }
      }
    }
    &--top {
      margin-bottom:rem(8px);
      bottom:100%;
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        border-width: 10px;
        left: 7px;
        bottom: -20px;
        @include themify($themes) {
          border-color: transparent transparent themed('foreground', 'error');
        }
        z-index: $zindex-tooltip;
        transform: rotate(180deg);
      }

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        bottom: -16px;
        left: 9px;
        border-width: 8px;
        transform: rotate(180deg);
        z-index: $zindex-tooltip + 2;
        @include themify($themes) {
          border-color: transparent transparent themed('background', 'light') transparent;
        }
      }
    }
  }
}
</style>

